import { render, staticRenderFns } from "./modal-order-details.vue?vue&type=template&id=53f81f62&scoped=true&lang=pug"
import script from "./modal-order-details.js?vue&type=script&lang=js&external"
export * from "./modal-order-details.js?vue&type=script&lang=js&external"
import style0 from "./modal-order-details.vue?vue&type=style&index=0&id=53f81f62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f81f62",
  null
  
)

export default component.exports